export const t = {
  ar: {
    // App General
    appName: "مغاسل القمر الأبيض",
    appTagline: "جودة النظافة بلمسة احترافية",
    loading: "جاري التحميل...",
    refresh: "تحديث",
    save: "حفظ",
    cancel: "إلغاء",
    close: "إغلاق",
    search: "بحث",
    all: "الكل",
    yes: "نعم",
    no: "لا",

    // Customer Page
    phoneLabel: "رقم الجوال",
    phonePlaceholder: "05xxxxxxxx",
    phoneError: "رقم الجوال غير صحيح. يجب أن يبدأ بـ 05 ويتكون من 10 أرقام",
    spinBtn: "أدر العجلة",
    welcomeTitle: "شارك وفز بجوائز مميزة!",
    welcomeSubtitle: "أدخل رقم جوالك للمشاركة في عجلة الحظ",
    alreadyParticipated: "لقد قمت بالمشاركة مسبقاً. يمكنك المشاركة مرة أخرى في:",
    activeCoupon: "لديك كوبون نشط غير مستخدم. يرجى استخدام كوبونك الحالي أولاً.",
    noOffers: "لا توجد عروض متاحة حالياً",
    spinWheelTitle: "عجلة الحظ",
    spinAgain: "مشاركة جديدة",
    copyCode: "نسخ الكود",
    copied: "تم النسخ!",
    shareWhatsapp: "شارك على واتساب",
    congratulations: "مبروك! 🎉",
    betterLuck: "حظاً أوفر في المرة القادمة",
    couponCode: "كود الكوبون",
    expiresAt: "صالح حتى",
    terms: "الشروط والأحكام",
    checkingEligibility: "جاري التحقق...",
    enterPhone: "أدخل رقم جوالك",
    securePrivate: "آمن وخاص",
    noSpam: "بدون رسائل مزعجة",
    instantWin: "فوز فوري",

    // Admin Common
    dashboard: "لوحة التحكم",
    offers: "إدارة العروض",
    coupons: "إدارة الكوبونات",
    verify: "التحقق من الكوبون",
    customers: "العملاء والمشاركات",
    settings: "الإعدادات والقيود",
    customerPage: "صفحة العميل",
    logout: "تسجيل الخروج",
    adminPanel: "لوحة تحكم المدير",
    systemManager: "مدير النظام",
    admin: "المدير",

    // Admin Login
    email: "البريد الإلكتروني / اسم المستخدم",
    password: "كلمة المرور",
    login: "دخول",
    loggingIn: "جاري التحقق...",
    loginError: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    noPermission: "ليس لديك صلاحية الوصول للوحة التحكم",

    // Dashboard
    dashboardTitle: "لوحة التحكم",
    dashboardSubtitle: "نظرة عامة على نظام العروض",
    totalSpins: "إجمالي اللفات",
    totalCustomers: "العملاء المشاركون",
    totalCoupons: "الكوبونات الصادرة",
    usageRate: "نسبة الاستخدام",
    usedCoupons: "كوبونات مستخدمة",
    unusedCoupons: "كوبونات غير مستخدمة",
    expiredCoupons: "كوبونات منتهية",
    topWonOffer: "أكثر العروض فوزاً",
    mostWonOffer: "أكثر عرض فوز:",
    mostUsedOffer: "أكثر عرض استخدام:",
    spinStats: "إحصائيات المشاركات",
    today: "اليوم",
    last7Days: "آخر 7 أيام",
    last30Days: "آخر 30 يوم",
    spins: "لفة",

    // Coupons
    couponManagement: "إدارة الكوبونات",
    searchByPhone: "بحث برقم الجوال",
    searchByCode: "بحث بكود الكوبون",
    allStatuses: "كل الحالات",
    allOffers: "كل العروض",
    code: "الكود",
    offer: "العرض",
    phone: "رقم الجوال",
    status: "الحالة",
    issued: "الإصدار",
    expires: "الانتهاء",
    actions: "إجراءات",
    markUsed: "استخدم",
    cancelCoupon: "إلغاء",
    note: "ملاحظة",
    adminNote: "ملاحظة إدارية",
    noteHere: "أدخل الملاحظة هنا...",
    noCoupons: "لا توجد كوبونات تطابق الفلتر",

    // Coupon Status
    unused: "غير مستخدم",
    used: "مستخدم",
    expired: "منتهي",
    cancelled: "ملغي",
    rejected: "مرفوض",
    pending: "معلق",

    // Customers
    customerManagement: "العملاء والمشاركات",
    totalSpinsCount: "عدد المشاركات",
    lastSpin: "آخر مشاركة",
    lastCoupon: "آخر كوبون",
    usedCount: "مستخدم",
    unusedCount: "غير مستخدم",
    noCustomers: "لا توجد بيانات عملاء بعد",

    // Settings
    settingsTitle: "الإعدادات والقيود",
    spinEnabled: "تفعيل العجلة",
    spinDisabledMessage: "رسالة إيقاف العجلة",
    spinsPerPhone: "عدد اللفات المسموحة لكل رقم",
    daysBetweenSpins: "عدد الأيام بين كل لفة",
    defaultValidity: "مدة صلاحية الكوبون الافتراضية (أيام)",
    preventMultiple: "منع أكثر من كوبون نشط لنفس الرقم",
    minInvoice: "الحد الأدنى للفاتورة بشكل عام",
    campaignName: "اسم الحملة",
    campaignStart: "تاريخ بداية الحملة",
    campaignEnd: "تاريخ نهاية الحملة",
    saveSettings: "حفظ الإعدادات",
    saving: "جاري الحفظ...",
    settingsSaved: "تم حفظ الإعدادات بنجاح!",

    // Offers
    offerManagement: "إدارة العروض",
    addOffer: "إضافة عرض",
    editOffer: "تعديل العرض",
    offerTitle: "اسم العرض",
    offerType: "نوع العرض",
    weight: "الوزن (احتمالية الظهور)",
    active: "نشط",
    inactive: "غير نشط",
    probability: "احتمالية",
    totalWeight: "الوزن الكلي",
    delete: "حذف",
    edit: "تعديل",
    noOffersList: "لا توجد عروض. أضف عرضاً جديداً للبدء.",

    // Verify
    verifyTitle: "التحقق من الكوبون",
    enterCouponCode: "أدخل كود الكوبون",
    orSearchByPhone: "أو ابحث برقم الجوال",
    verify: "تحقق",
    applyCoupon: "طبّق الكوبون",
    couponValid: "الكوبون صالح",
    couponUsed: "الكوبون مستخدم مسبقاً",
    couponExpired: "الكوبون منتهي الصلاحية",
    couponCancelled: "الكوبون ملغي",
    couponNotFound: "الكوبون غير موجود",
  },

  en: {
    // App General
    appName: "White Moon Laundry",
    appTagline: "Quality Cleaning with a Professional Touch",
    loading: "Loading...",
    refresh: "Refresh",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    search: "Search",
    all: "All",
    yes: "Yes",
    no: "No",

    // Customer Page
    phoneLabel: "Phone Number",
    phonePlaceholder: "05xxxxxxxx",
    phoneError: "Invalid phone number. Must start with 05 and be 10 digits",
    spinBtn: "Spin the Wheel",
    welcomeTitle: "Spin & Win Amazing Prizes!",
    welcomeSubtitle: "Enter your phone number to join the lucky wheel",
    alreadyParticipated: "You have already participated. You can participate again on:",
    activeCoupon: "You have an active unused coupon. Please use your current coupon first.",
    noOffers: "No offers available at the moment",
    spinWheelTitle: "Lucky Wheel",
    spinAgain: "New Spin",
    copyCode: "Copy Code",
    copied: "Copied!",
    shareWhatsapp: "Share on WhatsApp",
    congratulations: "Congratulations! 🎉",
    betterLuck: "Better luck next time",
    couponCode: "Coupon Code",
    expiresAt: "Valid Until",
    terms: "Terms & Conditions",
    checkingEligibility: "Checking...",
    enterPhone: "Enter your phone number",
    securePrivate: "Secure & Private",
    noSpam: "No spam messages",
    instantWin: "Instant Win",

    // Admin Common
    dashboard: "Dashboard",
    offers: "Manage Offers",
    coupons: "Manage Coupons",
    verify: "Verify Coupon",
    customers: "Customers & Spins",
    settings: "Settings & Limits",
    customerPage: "Customer Page",
    logout: "Logout",
    adminPanel: "Admin Dashboard",
    systemManager: "System Manager",
    admin: "Admin",

    // Admin Login
    email: "Email / Username",
    password: "Password",
    login: "Login",
    loggingIn: "Verifying...",
    loginError: "Invalid email or password",
    noPermission: "You do not have access to the admin panel",

    // Dashboard
    dashboardTitle: "Dashboard",
    dashboardSubtitle: "Overview of the offers system",
    totalSpins: "Total Spins",
    totalCustomers: "Participating Customers",
    totalCoupons: "Coupons Issued",
    usageRate: "Usage Rate",
    usedCoupons: "Used Coupons",
    unusedCoupons: "Unused Coupons",
    expiredCoupons: "Expired Coupons",
    topWonOffer: "Top Won Offers",
    mostWonOffer: "Most Won Offer:",
    mostUsedOffer: "Most Used Offer:",
    spinStats: "Participation Stats",
    today: "Today",
    last7Days: "Last 7 Days",
    last30Days: "Last 30 Days",
    spins: "spins",

    // Coupons
    couponManagement: "Coupon Management",
    searchByPhone: "Search by phone",
    searchByCode: "Search by coupon code",
    allStatuses: "All Statuses",
    allOffers: "All Offers",
    code: "Code",
    offer: "Offer",
    phone: "Phone",
    status: "Status",
    issued: "Issued",
    expires: "Expires",
    actions: "Actions",
    markUsed: "Mark Used",
    cancelCoupon: "Cancel",
    note: "Note",
    adminNote: "Admin Note",
    noteHere: "Enter note here...",
    noCoupons: "No coupons match the filter",

    // Coupon Status
    unused: "Unused",
    used: "Used",
    expired: "Expired",
    cancelled: "Cancelled",
    rejected: "Rejected",
    pending: "Pending",

    // Customers
    customerManagement: "Customers & Spins",
    totalSpinsCount: "Total Spins",
    lastSpin: "Last Spin",
    lastCoupon: "Last Coupon",
    usedCount: "Used",
    unusedCount: "Unused",
    noCustomers: "No customer data yet",

    // Settings
    settingsTitle: "Settings & Limits",
    spinEnabled: "Enable Wheel",
    spinDisabledMessage: "Wheel Disabled Message",
    spinsPerPhone: "Spins allowed per phone",
    daysBetweenSpins: "Days between spins",
    defaultValidity: "Default coupon validity (days)",
    preventMultiple: "Prevent multiple active coupons per phone",
    minInvoice: "Minimum invoice amount (global)",
    campaignName: "Campaign Name",
    campaignStart: "Campaign Start Date",
    campaignEnd: "Campaign End Date",
    saveSettings: "Save Settings",
    saving: "Saving...",
    settingsSaved: "Settings saved successfully!",

    // Offers
    offerManagement: "Offer Management",
    addOffer: "Add Offer",
    editOffer: "Edit Offer",
    offerTitle: "Offer Title",
    offerType: "Offer Type",
    weight: "Weight (probability)",
    active: "Active",
    inactive: "Inactive",
    probability: "Probability",
    totalWeight: "Total Weight",
    delete: "Delete",
    edit: "Edit",
    noOffersList: "No offers. Add a new offer to get started.",

    // Verify
    verifyTitle: "Verify Coupon",
    enterCouponCode: "Enter coupon code",
    orSearchByPhone: "Or search by phone number",
    verify: "Verify",
    applyCoupon: "Apply Coupon",
    couponValid: "Coupon is valid",
    couponUsed: "Coupon already used",
    couponExpired: "Coupon expired",
    couponCancelled: "Coupon cancelled",
    couponNotFound: "Coupon not found",
  }
};

// NOTE: useT is defined in AppContext.jsx to avoid circular imports
// Import it from there: import { useT } from "@/lib/AppContext"